'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

require('./Tooltip.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var isOpen = this.props.open === true;

      var content = null;

      var anchor = {
        right: 0,
        left: 0,
        bottom: 0,
        top: 0,
        height: 0,
        width: 0
      };

      var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var styleMargin = 8;

      if (this.props.anchor) {
        anchor = this.props.anchor.getBoundingClientRect();
      }

      var style = {};

      if (windowHeight - anchor.bottom > anchor.top) {
        style.top = anchor.top + anchor.height + styleMargin;
      } else {
        style.bottom = windowHeight + anchor.height + styleMargin - anchor.bottom;
      }

      if (windowWidth - anchor.right > anchor.left) {
        style.left = anchor.left;
      } else {
        style.right = windowWidth - anchor.right;
      }

      if (this.props.position === 'left') {

        style.right = windowWidth - anchor.right;
        delete style.left;
      } else if (this.props.position === 'right') {

        style.left = anchor.left;
        delete style.right;
      } else if (this.props.position === 'top') {

        style.bottom = windowHeight - anchor.bottom;
        delete style.top;
      } else if (this.props.position === 'bottom') {

        style.top = anchor.top;
        delete style.bottom;
      }

      if (isOpen) {
        content = _react2.default.createElement(
          'div',
          {
            className: 'rsg-github-tooltip rsg-animation-container',
            key: isOpen,
            style: style
          },
          this.props.children
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'rsg-github-tooltip',
          onBlur: this.props.onBlur,
          onClick: this.props.onClick,
          onMouseEnter: this.props.onMouseEnter,
          onMouseLeave: this.props.onMouseLeave
        },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionEnterTimeout: 100,
            transitionLeaveTimeout: 100,
            transitionName: 'rsg-github-tooltip-animation'
          },
          content
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  // anchor
  anchor: _propTypes2.default.object,

  // children
  children: _propTypes2.default.object,

  // onBlur
  onBlur: _propTypes2.default.bool,

  // onClick
  onClick: _propTypes2.default.func,

  // onMouseEnter
  onMouseEnter: _propTypes2.default.func,

  // OonMouseLeave
  onMouseLeave: _propTypes2.default.func,

  // open
  open: _propTypes2.default.bool,

  // position
  position: _propTypes2.default.string
};

exports.default = Tooltip;